module.exports = __webpack_public_path__ + "static/media/WellnessTipsSelfCareAtHome.2ee9b9b9.jpg";